var _defs, _path, _path2, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Septic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Puay0ea85WEL3dezIH9~6a",
    x1: 19.5,
    x2: 19.5,
    y1: 554.011,
    y2: 538.432,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 217",
    gradientTransform: "matrix(1 0 0 -1 0 572.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Puay0ea85WEL3dezIH9~6b",
    x1: 24,
    x2: 24,
    y1: 541.063,
    y2: 529.011,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 216",
    gradientTransform: "matrix(1 0 0 -1 0 572.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9360c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#b5350c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ab320b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Puay0ea85WEL3dezIH9~6c",
    x1: 15.282,
    x2: 39.971,
    y1: 29.717,
    y2: 5.029,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 230",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Puay0ea85WEL3dezIH9~6d",
    x1: 36.997,
    x2: 36.997,
    y1: 567.946,
    y2: 559.533,
    xlinkHref: "#Puay0ea85WEL3dezIH9~6a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Puay0ea85WEL3dezIH9~6a)",
    d: "M26.56086,25.30875l-6.87634-6.87633a1.49909,1.49909,0,0,0-2.12017,0l-4.05893,4.05892c-1.387,1.387-1.50617,7.61106-1.50542,9.762a.74263.74263,0,0,0,.74.74521c2.14192.01575,8.321-.069,9.762-1.50991l4.05893-4.05893A1.5,1.5,0,0,0,26.56086,25.30875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Puay0ea85WEL3dezIH9~6b)",
    d: "M3,31V41a1.99945,1.99945,0,0,0,2,2H43a1.99945,1.99945,0,0,0,2-2V31Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 2,
    x: 3,
    y: 29,
    fill: "#d43a02"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 34,
    r: 1,
    fill: "#d43a02"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 34,
    r: 1,
    fill: "#d43a02"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 34,
    r: 1,
    fill: "#d43a02"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 34,
    r: 1,
    fill: "#d43a02"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 34,
    r: 1,
    fill: "#d43a02"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 37,
    r: 1,
    fill: "#d43a02"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 34,
    r: 1,
    fill: "#d43a02"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 40,
    r: 1,
    fill: "#d43a02"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 40,
    r: 1,
    fill: "#d43a02"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 40,
    r: 1,
    fill: "#d43a02"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 40,
    r: 1,
    fill: "#d43a02"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 40,
    r: 1,
    fill: "#d43a02"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 40,
    r: 1,
    fill: "#d43a02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Puay0ea85WEL3dezIH9~6c)",
    d: "M39.709,9.54443a.99876.99876,0,0,0-1.41406-.00293L36.53516,11.293a2.049,2.049,0,0,1-2.82813,0A1.99928,1.99928,0,0,1,33.709,8.46289l1.75-1.75732a1.00024,1.00024,0,0,0-1.418-1.41114L32.293,7.05029a3.95947,3.95947,0,0,0-.60718,4.84986L18.293,25.293A.99989.99989,0,1,0,19.707,26.707L33.1001,13.314a3.959,3.959,0,0,0,4.84717-.60546l1.75781-1.75A.99965.99965,0,0,0,39.709,9.54443Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Puay0ea85WEL3dezIH9~6d)",
    d: "M39.20568,11.7637,33.23023,5.78824a.78546.78546,0,0,1,0-1.11115l.44686-.44686a.78546.78546,0,0,1,1.11115,0l5.97546,5.97545a.78549.78549,0,0,1,0,1.11116l-.44686.44686A.78549.78549,0,0,1,39.20568,11.7637Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Septic);
export default __webpack_public_path__ + "static/media/icons8-septic.0fc028f9be85c8fa80434b5b5684da3b.svg";
export { ForwardRef as ReactComponent };